// extracted by mini-css-extract-plugin
export default {"reminders":"Reminders_reminders__vWos1","reminders_dark":"Reminders_reminders_dark__yAHTR"};